import { observer } from 'mobx-react';
import React, { Component } from 'react';
import { FaTimes } from 'react-icons/fa';
import voiceStore from '../stores/voiceStore';

const VideoModal = observer(class VideoModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isPlaying: false,
    };
    this.videoRef = React.createRef();
  }

  componentDidMount() {
    document.addEventListener('keydown', this.handleKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown);
  }

  handleKeyDown = (event) => {
    if (event.key === 'Escape') {
      voiceStore.setVideoModal(null)
    }
  };

  render() {
    return (
      <div
        id="modalBackground"
        className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[100]"
        onClick={() => voiceStore.setVideoModal(null)}
      >
        <div className="bg-white lg:w-1/3 p-4 rounded shadow-lg" onClick={(e) => e.stopPropagation()}>
          <div className="flex justify-between items-center border-b pb-2">
            <h2 className="text-xl">{voiceStore.videoModal.fileName}</h2>
            <button onClick={() => voiceStore.setVideoModal(null)} className="text-red-500">
              <FaTimes size={20} color='black' />
            </button>
          </div>
          <div className="mt-4 relative group">
            <video
              ref={this.videoRef}
              className="w-full"
              onError={(e) => console.error('Failed to load video:', e)}
              controls
            >
              <source src={voiceStore.videoModal.video} type="video/mp4" />
              Your browser does not support the video.
            </video>
          </div>
        </div>
      </div>
    );
  }
});

export default VideoModal;
